(function () {
  'use strict';

  if (typeof window === 'undefined' || !window.customElements || window.customElements.get('mnb-listing-preview')) return;

  var CONDITION_LABELS = {
    'as-good-as-new': 'As good as new',
    'good-condition': 'Good condition',
    'needs-some-work': 'Needs some work'
  };

  var COLOUR_KEYWORDS = {
    Black: 1, Blue: 1, Green: 1, Grey: 1, Orange: 1, Purple: 1, Red: 1, White: 1
  };
  var COMPACT_VIEWPORT_QUERY = '(max-width: 1023px)';

  function cleanText(value) {
    return String(value == null ? '' : value).trim().replace(/\s+/g, ' ');
  }

  function formatGBP(value) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      maximumFractionDigits: 0
    }).format(Number(value) || 0);
  }

  function previewTitle(state) {
    var title = [state.BikeYear, state.Brand, state.Model].map(cleanText).filter(Boolean).join(' ');
    return title || 'Bike Brand & Model';
  }

  function conditionLabel(value) {
    var label = cleanText(value);
    return CONDITION_LABELS[label] || label;
  }

  function previewDescription(value) {
    var description = cleanText(value);
    return description.length > 140 ? description.slice(0, 137).trim() + '…' : description;
  }

  function specValue(state, keys) {
    return keys.map(function (key) {
      return cleanText(state[key]);
    }).filter(function (value) {
      return value && value.toLowerCase() !== 'not sure';
    }).join(' ');
  }

  function brandModelSpecValue(state, brandKey, modelKey, legacyKey) {
    return specValue(state, [brandKey, modelKey]) || specValue(state, [legacyKey]);
  }

  function previewSpecs(state) {
    return [
      { label: 'Size', value: specValue(state, ['BikeSizing', 'BikeFrameSize2']) },
      { label: 'Year', value: specValue(state, ['BikeYear']) },
      { label: 'Type', value: specValue(state, ['BikeType', 'bike_data_Category']) },
      { label: 'Frame', value: specValue(state, ['bike_data_FrameMaterial']) },
      { label: 'Groupset', value: brandModelSpecValue(state, 'internal_spec_groupset_brand', 'internal_spec_groupset_model', 'bike_data_Groupset') },
      { label: 'Wheelset', value: brandModelSpecValue(state, 'internal_spec_wheelset_brand', 'internal_spec_wheelset_model', 'bike_data_Wheelset') }
    ].filter(function (item) {
      return item.value;
    });
  }

  function photosFrom(state) {
    var previews = Array.isArray(state.internal_media_additional_preview) ? state.internal_media_additional_preview : [];
    var urls = Array.isArray(state.media_additional) ? state.media_additional : [];
    return previews.length ? previews : urls;
  }

  function isMobileViewport(mediaQuery) {
    if (mediaQuery) return mediaQuery.matches;
    if (window.matchMedia) return window.matchMedia(COMPACT_VIEWPORT_QUERY).matches;
    return window.innerWidth < 1024;
  }

  function renderMediaInto(figure, photos, index, title) {
    var img = figure.querySelector('[data-preview-image]');
    var empty = figure.querySelector('[data-preview-image-empty]');
    var prev = figure.querySelector('[data-preview-prev]');
    var next = figure.querySelector('[data-preview-next]');
    var counter = figure.querySelector('[data-preview-counter]');
    var dots = figure.querySelector('[data-preview-dots]');
    var source = photos[index] || '';

    if (source) {
      img.src = source;
      img.alt = title + ' preview image';
      img.hidden = false;
      empty.hidden = true;
    } else {
      img.removeAttribute('src');
      img.alt = '';
      img.hidden = true;
      empty.hidden = false;
    }

    var multiple = photos.length > 1;
    prev.hidden = !multiple;
    next.hidden = !multiple;
    counter.hidden = !multiple;
    if (multiple) counter.textContent = (index + 1) + ' of ' + photos.length;

    dots.hidden = !multiple;
    while (dots.firstChild) dots.removeChild(dots.firstChild);
    if (multiple) {
      photos.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'nl-preview-dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('data-preview-dot', String(i));
        dot.setAttribute('aria-label', 'Show photo ' + (i + 1));
        dots.appendChild(dot);
      });
    }
  }

  function previewNodes(root, selector) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root._drawer && !root.contains(root._drawer)) {
      nodes = nodes.concat(Array.prototype.slice.call(root._drawer.querySelectorAll(selector)));
    }
    return nodes;
  }

  function setText(root, selector, value) {
    previewNodes(root, selector).forEach(function (node) {
      node.textContent = value;
    });
  }

  function bodyMarkup() {
    return (
      '<figure class="nl-preview-media" data-preview-media>' +
        '<img data-preview-image alt="" hidden>' +
        '<figcaption data-preview-image-empty>No photo yet</figcaption>' +
        '<button type="button" class="nl-preview-nav nl-preview-nav--prev" data-preview-prev aria-label="Previous photo" hidden>‹</button>' +
        '<button type="button" class="nl-preview-nav nl-preview-nav--next" data-preview-next aria-label="Next photo" hidden>›</button>' +
        '<p class="nl-preview-counter" data-preview-counter hidden></p>' +
        '<div class="nl-preview-dots" data-preview-dots hidden></div>' +
      '</figure>' +
      '<div class="nl-preview-price-row">' +
        '<p class="nl-preview-price" data-preview-price>£0</p>' +
        '<p class="nl-record nl-preview-sponsored" data-preview-sponsored hidden>' +
          '<span>Sponsored listing</span>' +
          '<button type="button" class="nl-preview-sponsored__dismiss" data-preview-sponsored-dismiss aria-label="Remove sponsored listing">×</button>' +
        '</p>' +
      '</div>' +
      '<div class="nl-preview-chips">' +
        '<p class="nl-record" data-preview-condition hidden></p>' +
        '<span class="nl-preview-colour" data-preview-colour hidden>' +
          '<span class="nl-preview-swatch" data-preview-swatch></span>' +
          '<span data-preview-colour-label></span>' +
        '</span>' +
      '</div>' +
      '<h2 data-preview-title>Bike Brand &amp; Model</h2>' +
      '<div class="nl-preview-specs" data-preview-specs></div>' +
      '<p data-preview-description hidden></p>'
    );
  }

  function template(id) {
    var titleId = 'nl-preview-drawer-title-' + id;
    var drawerBody = bodyMarkup().replace('<h2 data-preview-title>', '<h2 id="' + titleId + '" data-preview-title>');
    return (
      '<div class="nl-preview-card" data-preview-desktop>' +
        '<p class="nl-record">Listing preview</p>' +
        bodyMarkup() +
      '</div>' +
      '<mnb-bottom-sheet class="ink nl-preview-bottom-sheet" portal data-preview-drawer aria-labelledby="' + titleId + '" style="--bottom-sheet-max-height: min(85dvh, 720px); --bottom-sheet-background: var(--fog-100); --bottom-sheet-border: var(--divider); --bottom-sheet-color: var(--ink-900); --bottom-sheet-shadow: inset 0 1px 0 var(--divider)">' +
        '<div class="nl-preview-drawer__content">' +
          '<div class="nl-preview-drawer__card">' + drawerBody + '</div>' +
        '</div>' +
      '</mnb-bottom-sheet>'
    );
  }

  class MnbListingPreview extends HTMLElement {
    constructor() {
      super();
      MnbListingPreview.instanceId += 1;
      this._id = MnbListingPreview.instanceId;
      this._state = {};
      this._pricing = {};
      this._photos = [];
      this._photoIndex = 0;
      this._onClick = this._onClick.bind(this);
      this._onViewportChange = this._onViewportChange.bind(this);
    }

    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      if (!this._built) {
        this._built = true;
        this.innerHTML = template(this._id);
        this._drawer = this.querySelector('[data-preview-drawer]');
        this._paint();
      }
      this.addEventListener('click', this._onClick);
      // The open drawer is portalled into document.body, so clicks inside it
      // never bubble through this element — listen on the sheet itself too.
      if (this._drawer) this._drawer.addEventListener('click', this._onClick);
      this._mediaQuery = window.matchMedia ? window.matchMedia(COMPACT_VIEWPORT_QUERY) : null;
      if (this._mediaQuery) {
        if (this._mediaQuery.addEventListener) this._mediaQuery.addEventListener('change', this._onViewportChange);
        else if (this._mediaQuery.addListener) this._mediaQuery.addListener(this._onViewportChange);
      }
    }

    disconnectedCallback() {
      if (!this._connected) return;
      this.closeDrawer();
      this.removeEventListener('click', this._onClick);
      if (this._drawer) this._drawer.removeEventListener('click', this._onClick);
      if (this._mediaQuery) {
        if (this._mediaQuery.removeEventListener) this._mediaQuery.removeEventListener('change', this._onViewportChange);
        else if (this._mediaQuery.removeListener) this._mediaQuery.removeListener(this._onViewportChange);
      }
      this._mediaQuery = null;
      this._connected = false;
    }

    update(state, pricing) {
      this._state = state || {};
      this._pricing = pricing || {};
      this._photos = photosFrom(this._state);
      if (this._photoIndex >= this._photos.length) this._photoIndex = 0;
      this._paint();
    }

    openDrawer() {
      if (this._drawer && isMobileViewport(this._mediaQuery)) this._drawer.open();
    }

    closeDrawer() {
      if (this._drawer) this._drawer.close();
    }

    _onViewportChange(event) {
      if (!event.matches) this.closeDrawer();
    }

    _onClick(event) {
      var prevBtn = event.target.closest('[data-preview-prev]');
      var nextBtn = event.target.closest('[data-preview-next]');
      var dot = event.target.closest('[data-preview-dot]');
      var dismiss = event.target.closest('[data-preview-sponsored-dismiss]');

      if (dismiss) { this._removeSponsored(); return; }
      if (prevBtn) { this._step(-1); return; }
      if (nextBtn) { this._step(1); return; }
      if (dot) { this._photoIndex = Number(dot.getAttribute('data-preview-dot')) || 0; this._paint(); return; }
    }

    // The preview is a view only — ownership of sponsoredListing lives in the
    // form store (new-listing.js), so removing the badge here is an intent
    // published as a bubbling event the form listens for.
    _removeSponsored() {
      this.dispatchEvent(new CustomEvent('mnb:remove-sponsored', { bubbles: true, composed: true }));
    }

    _step(delta) {
      var len = this._photos.length;
      if (!len) return;
      this._photoIndex = (this._photoIndex + delta + len) % len;
      this._paint();
    }

    _paint() {
      var state = this._state;
      var pricing = this._pricing;
      var title = previewTitle(state);
      var specs = previewSpecs(state);
      var colour = cleanText(state.BikeColour);

      setText(this, '[data-preview-title]', title);
      setText(this, '[data-preview-price]', formatGBP(pricing.displayPrice));
      var condition = conditionLabel(state.condition);
      var description = previewDescription(state.BikeShortDescription);
      previewNodes(this, '[data-preview-condition]').forEach(function (node) {
        node.hidden = !condition;
        node.textContent = condition;
      });
      previewNodes(this, '[data-preview-description]').forEach(function (node) {
        node.hidden = !description;
        node.textContent = description;
      });

      previewNodes(this, '[data-preview-sponsored]').forEach(function (node) {
        node.hidden = !state.sponsoredListing;
      });

      previewNodes(this, '[data-preview-colour]').forEach(function (node) {
        var swatch = node.querySelector('[data-preview-swatch]');
        var label = node.querySelector('[data-preview-colour-label]');
        node.hidden = !colour;
        if (!colour) return;
        label.textContent = colour;
        var showSwatch = colour !== 'Other' && Object.prototype.hasOwnProperty.call(COLOUR_KEYWORDS, colour);
        swatch.hidden = !showSwatch;
        if (showSwatch) swatch.style.backgroundColor = colour.toLowerCase();
      });

      previewNodes(this, '[data-preview-specs]').forEach(function (list) {
        while (list.firstChild) list.removeChild(list.firstChild);
        specs.forEach(function (spec) {
          var item = document.createElement('span');
          var label = document.createElement('span');
          var value = document.createElement('span');
          item.className = 'nl-preview-spec';
          label.className = 'nl-preview-spec__label';
          value.className = 'nl-preview-spec__value';
          label.textContent = spec.label;
          value.textContent = spec.value;
          item.appendChild(label);
          item.appendChild(value);
          list.appendChild(item);
        });
      });

      var self = this;
      previewNodes(this, '[data-preview-media]').forEach(function (figure) {
        renderMediaInto(figure, self._photos, self._photoIndex, title);
      });
    }
  }

  MnbListingPreview.instanceId = 0;

  window.customElements.define('mnb-listing-preview', MnbListingPreview);
})();
